module.exports = __webpack_public_path__ + "6c42fe6c2f6405e77ff1ff0fbfe0b9cb.png";